import React from "react";
import { Link } from "react-router-dom";
import { Menu, Icon } from "antd";

export const routes = {
  NumberEdit: {
    icon: "",
    title: "$[action]參數設定",
    path: "/net-zero/number/:id",
    showBreadcrumb: true,
    key: "NumberEdit",
  },
  HomeEdit: {
    icon: "home",
    title: "首頁設定",
    path: "/net-zero/home",
    showBreadcrumb: true,
    key: "HomeEdit",
  },
  ImageEdit: {
    icon: "",
    title: "$[action]圖片",
    path: "/net-zero/image/:id",
    showBreadcrumb: true,
    key: "ImageEdit",
  },
  ImageList: {
    icon: "picture",
    title: "圖片列表",
    path: "/net-zero/images",
    showBreadcrumb: true,
    key: "ImageList",
  },
  FileEdit: {
    icon: "",
    title: "$[action]檔案",
    path: "/net-zero/file/:id",
    showBreadcrumb: true,
    key: "FileEdit",
  },
  FileList: {
    icon: "file",
    title: "檔案列表",
    path: "/net-zero/files",
    showBreadcrumb: true,
    key: "FileList",
  },
  NationEdit: {
    icon: "",
    title: "$[action]國際簡訊",
    path: "/net-zero/nation/:id",
    showBreadcrumb: true,
    key: "NationEdit",
  },
  NationList: {
    icon: "global",
    title: "國際簡訊",
    path: "/net-zero/nations",
    showBreadcrumb: true,
    key: "NationList",
  },
  ActivityList: {
    icon: "team",
    title: "活動列表",
    path: "/net-zero/activities",
    showBreadcrumb: true,
    key: "ActivityList",
  },
  ActivityEdit: {
    icon: "team",
    title: "$[action]活動列表",
    path: "/net-zero/activity/:id",
    showBreadcrumb: true,
    key: "ActivityEdit",
  },
  VideoList: {
    icon: "youtube",
    title: "影片列表",
    path: "/net-zero/videos",
    showBreadcrumb: true,
    key: "VideoList",
  },
  VideoEdit: {
    icon: "",
    title: "$[action]影片",
    path: "/net-zero/video/:id",
    showBreadcrumb: true,
    key: "VideoEdit",
  },
};

export const routeMap = {
  ImageList: {
    ImageEdit: undefined,
  },
  HomeEdit: {
    NumberEdit: undefined,
  },
  FileList: {
    FileEdit: undefined,
  },
  NationList: {
    NationEdit: undefined,
  },
  ActivityList: {
    ActivityEdit: undefined,
  },
  VideoList: {
    VideoEdit: undefined,
  },
};

export const flatRouteMap = (() => {
  let res = {};
  function findIdxRoute(res, route, parent = []) {
    if (!route) return;
    Object.keys(route).forEach((x) => {
      if (!res[x]) res[x] = [...parent, x];
      if (route[x]) findIdxRoute(res, route[x], res[x]);
    });
  }

  findIdxRoute(res, routeMap);
  return res;
})();

/**
 *
 * @param {string} name
 * @param {string} object.key
 * @param {[string|object]} object.children
 */
export const menuByRouteName = (name = "") => {
  if (typeof name === "object") {
    const _key = Object.keys(name);
    if (_key.lenght === 0) return;
    const key = _key[0];
    const current = routes[key];
    if (!current) return;
    const childs = name[key] || [];
    const { icon, title } = current;

    return (
      <Menu.SubMenu
        key={key}
        title={
          <span>
            <Icon type={icon} />
            <span>{title}</span>
          </span>
        }
      >
        {childs.map((r) => menuByRouteName(r))}
      </Menu.SubMenu>
    );
  }

  const current = routes[name];
  if (!current) return;
  else {
    const { path, icon, title } = current;
    return (
      <Menu.Item key={`${path}`}>
        <Link to={path}>
          <Icon type={icon} />
          <span>{title}</span>
        </Link>
      </Menu.Item>
    );
  }
};
